export const SET_ACCOUNT_NUMBER = 'SET_ACCOUNT_NUMBER';
export const SET_ACCOUNT_INDEX = 'SET_ACCOUNT_INDEX';
export const SET_BIP_39_PASSPHRASE = 'SET_BIP_39_PASSPHRASE';
